module.exports = __webpack_public_path__ + "img/charactors2.6caec469.png";